<cdx-alert [options]="alertOptions" [alertTemplate]="alertTemplate" *ngIf="canShowAlert()">
    <ng-template #alertTemplate>
      <div>
          {{'envelopeEdit.responsibleAlert' | translate}}
      </div>
    </ng-template>
</cdx-alert>
<div class="d-sm-block col-sm-4 mt-3">
  <span class="d-flex ml-auto">
    {{'envelope.signatory.accessAuthentication' | translate}}
    <fa-icon ngbTooltip="{{'envelope.signatory.tooltip.accessAuthentication' | translate}}" placement="left"
      class="ml-1 fa-gray mr-1" size="sm" [icon]="['fas','question-circle']">
    </fa-icon>
    <cdx-toggle-switch [toggledOn]="accessAuthentication" (toggle)="changeAccessAuthentication($event)">
    </cdx-toggle-switch>
  </span>
</div>
<div class="row align-items-center pb-2 justify-content-end">
  <div class="d-flex">
    <button class="cdx-button cdx-button--icon cdx-button--lg mr-1 fa-gray" placement="left auto"
      ngbTooltip="{{ 'edit' | translate | titlecase }}" *ngIf="canShowButtonEdit()"
      (click)="showEditSignatory(modalEditSignatoryForm)">
      <fa-icon class="fa-fw cdx-button__icon" [icon]="['far','edit']"></fa-icon>
    </button>
    <button class="cdx-button cdx-button--icon cdx-button--lg mr-1 fa-gray" placement="left auto"
      ngbTooltip="{{ 'contacts.tooltip.disassociateContact' | translate }}"
      *ngIf="canShowButtonRemove()" (click)="showConfirmationDelete(confirmDeleteModal)">
      <fa-icon class="fa-fw cdx-button__icon" [icon]="['far','minus-circle']"></fa-icon>
    </button>
    <button *ngIf="isOrdered" class="cdx-button cdx-button--icon cdx-button--lg mr-1 fa-gray" placement="left auto"
      ngbTooltip="{{'envelope.signatory.tooltip.orderAdjust' | translate}}"
      (click)="showSignatoriesOrderModal(modalEditSignatoriesOrder)">
      <fa-icon class="fa-fw cdx-button__icon" [icon]="['far','list-ol']"></fa-icon>
    </button>
    <button class="cdx-button cdx-button--icon cdx-button--lg mr-1 border-less fa-gray"
      (click)="showAddSignatoriesBookModal(modalAddSignatoriesBook)" placement="left"
      ngbTooltip="{{ 'add' | translate | titlecase }}">
      <fa-icon class="fa-fw cdx-button__icon" [icon]="['far','plus-circle']"></fa-icon>
    </button>
    <cdx-toolbar-search #serchMenu (onTyping)="onSearch($event)" [value]="searchText"
      [placeholder]="'search' | translate | titlecase" [maxlength]="255" [debounceTime]="600">
    </cdx-toolbar-search>
  </div>
</div>
<div class="table-responsive table__container p-2">
  <ng-container *ngIf="canShowGrid(); else blankSlateTable">
    <table class="w-auto table table-striped table-border round-corner">
      <thead>
        <tr>
          <th scope="col" width="35" class="text-center">
            <cdx-checkbox *ngIf="canShowGrid()" [options]="{span: '',checkSquare: true}"
              [isChecked]="checkboxAllElements" (checked)="onCheckboxAll($event)"></cdx-checkbox>
          </th>
          <th *ngIf="this.envelopeEditService.isOrdered" scope="col" class="w-60-table text-left">{{ 'order' | translate |
            titlecase }}</th>
          <th scope="col" class="text-left">{{ 'name' | translate | titlecase }}</th>
          <th scope="col" class="text-left">{{ 'mail' | translate | titlecase }}</th>
          <th *ngIf="checkLanguagePtEnvelope()" scope="col" class="text-left">{{ 'ssn' | translate | uppercase }} </th>
          <th *ngIf="canSendWhatsApp" scope="col" class="text-left">{{ 'telephone' | translate | titlecase}} </th>
          <th scope="col" class="text-left">{{ 'envelope.signatory.signatureTypeText' | translate  }} </th>
          <th scope="col" class="text-left">{{ 'envelope.signatory.subscriberTypeText' | translate  }} </th>
          <th scope="col" class="text-left">{{ 'status' | translate | titlecase }}</th>
          <th *ngIf="canSendWhatsApp || isSignFreemium" scope="col" class="text-center">{{ 'envelope.signatory.sendingByWhatsapp' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let element of filteredElements; let i = index" class="cursor"
          [ngClass]="{'row-success': element.checked === true }">
          <td width="35" class="text-center text-overflow-none">
            <cdx-checkbox [options]="{span: '',checkSquare: true}" [isChecked]="element.checked"
              (checked)="onCheckbox($event, element)"></cdx-checkbox>
          </td>
          <td *ngIf="this.envelopeEditService.isOrdered" class="text-truncate text-left">{{ element.order }}</td>
          <td class="text-truncate text-left">{{ element.name }}</td>
          <td class="text-truncate text-left">{{ element.mail | mailObfuscate }}</td>
          <td *ngIf="checkLanguagePtEnvelope()" class="text-truncate text-left">{{ canObfuscateCpfCnpj(element.ssnWithMask) }}</td>
          <td *ngIf="canSendWhatsApp" class="text-truncate text-left">{{ element.phoneNumber ? (element.phoneNumber | phoneObfuscate) : '-' }}</td>
          <td class="text-truncate text-left">{{ (element.status === SignatureStatus.Signed ?
            element.signatureTypeSelectedValue : element.signatureTypeValue) | translate | titlecase }}</td>
          <td class="text-truncate text-left">
            {{ element.signatoryTypeRole.isDefault ? (element.signatoryTypeRole.name | translate | titlecase) : (element.signatoryTypeRole.name) }}
            <cdx-tag class="ml-2" [options]="inactiveTag" *ngIf="!element.signatoryTypeRole.isActive"></cdx-tag>
          </td>
          <td class="text-truncate text-left">
            <cdx-tag *ngIf="element.status === SignatureStatus.Awaiting" [options]="tagWaiting"></cdx-tag>
            <cdx-tag *ngIf="element.status === SignatureStatus.Signed" [options]="tagSigned"></cdx-tag>
            <cdx-tag *ngIf="element.status === SignatureStatus.Declined" [options]="tagRejected"></cdx-tag>
          </td>
          <td *ngIf="canSendWhatsApp && !isSignFreemium" align="center">
            <cdx-toggle-switch class="pointerMouse" [disabled]="!canToggleWhatsApp(element)"
              [toggledOn]="element.sendWhatsApp"
              (toggle)="needSendWhatsapp($event, element.id, element.idAdd)">
            </cdx-toggle-switch>
          </td>
          <td *ngIf="isSignFreemium" align="center">
            <div (click)="toastWhatsFree()" class="pointerMouse">
              <cdx-toggle-switch [disabled]="true"></cdx-toggle-switch>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </ng-container>
</div>

<ng-template #blankSlateSearchTemplate>
  <ng-container>
    <cdx-blankslate [options]="blankSlateSearch" (buttonClick)="onBlankSlateSearchClick($event)">
      {{'envelope-edit.blankSlate.signatoryNotFound' | translate}}</cdx-blankslate>
  </ng-container>
</ng-template>

<ng-template #modalEditSignatoryForm>
  <app-contact-form
    (modalCloseEmitter)="confirmModalClose()"
    (addSignatoryToTable)="insertOrUpdateSignatoryEdit($event)"
    [participantType]="participantType.Signatory"
    [userToEdit]="elementSelected"
    [elements]="signatories">
  </app-contact-form>
</ng-template>

<ng-template #blankSlateTable>
  <ng-container *ngIf="(searchText === ''); else blankSlateSearchTemplate">
    <cdx-blankslate [options]="blankSlate" (buttonClick)="showAddSignatoriesBookModal(modalAddSignatoriesBook)">
      <span [innerHTML]="'envelope.signatory.blankSlateText' | translate"></span>
    </cdx-blankslate>
  </ng-container>
</ng-template>

<ng-template #modalAddSignatoriesBook>
  <app-participant-modal
    (closeModalClick)="confirmModalClose()"
    (submitModalClick)="submitSignatoriesBookModalClick($event)"
    [participantTypeInput]="participantType.Signatory"
    [enableEditContact]="false">
  </app-participant-modal>
</ng-template>

<ng-template #modalEditSignatoriesOrder>
  <app-edit-signatories-order (closeModalClick)="confirmModalClose()"
    (submitModalClick)="submitSignatoriesOrderModalClick($event)">
  </app-edit-signatories-order>
</ng-template>

<ng-template #confirmDeleteModal>
  <app-confirm-modal
    [HeaderText]="'envelope.signatory.confirm-disassociate-delete-modal.headerText'"
    [MessageText]="'envelope.signatory.confirm-disassociate-delete-modal.messageTextOnEdit'"
    (closeModalClick)="confirmModalClose()"
    (confirmModalClick)="confirmModalYesClick()"
    [ButtonConfirmText]="'disassociateModalActions.remove'"
    [ButtonCancelText]="'disassociateModalActions.cancel'"
    [IsApprovalConfirm]="false"
    [modalIntentType]="modalIntentType.DANGER"
  >
  </app-confirm-modal>
</ng-template>

<ng-template #modalReuseSignatures>
  <app-modal-reuse-signatures [isMoreThanOneRejected]="isMoreThanOneRejected" (closeModal)="closeModalReuseSignatures()"
    (confirmModal)="confirmModalReuseSignatures($event)"></app-modal-reuse-signatures>
</ng-template>
